'use client';

import Error from 'next/error';

export default function GlobalError({
	error,
	reset
}: {
	error: Error & {digest?: string};
	reset: () => void;
}) {
	console.log(error);

	return (
		<html>
			<body>
				<h2>Something went wrong!</h2>
				<button onClick={() => reset()}>Try again</button>
			</body>
		</html>
	);
}
